// ** React Imports
import { Fragment, useEffect } from 'react'

// ** Reactstrap Imports
import { Card, CardTitle, CardHeader } from 'reactstrap'

// ** Styles
import '@styles/react/libs/tables/react-dataTable-component.scss'
import { getCatalogSocieties, getSignatories } from './thunks'
import { useDispatch } from 'react-redux'
import SignatoriesTable from './components/SignatoriesTable'
import { getCompanyPositions } from '../company-positions/thunks'

const SignatoriesList = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getSignatories('socied'))
    dispatch(getCatalogSocieties())
    dispatch(getCompanyPositions())
  }, [])
  return (
    <Fragment>
      <Card>
        <CardHeader className="flex-md-row flex-column align-md-items-center align-items-start border-bottom">
          <CardTitle tag="h4">Firmantes de sociedad</CardTitle>
        </CardHeader>
      </Card>
      <Card>
        <SignatoriesTable />
      </Card>
    </Fragment>
  )
}

export default SignatoriesList
